import { render, staticRenderFns } from "./ContactTab.vue?vue&type=template&id=4f09adc0&scoped=true"
import script from "./ContactTab.vue?vue&type=script&lang=js"
export * from "./ContactTab.vue?vue&type=script&lang=js"
import style0 from "./ContactTab.vue?vue&type=style&index=0&id=4f09adc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f09adc0",
  null
  
)

export default component.exports